import { apiUrl }  from "../constants";
var axios = require('axios');
var request = axios.create({
    baseURL: apiUrl,
    headers: {'Authorization':localStorage.getItem('token'),'Content-Type':'application/json'}
})
export default class Player_MatchApi {
    static getAll() {
        return request.get('/playerMatch');
    }

    static getByMatch(match_id){
        console.log("MATCH_ID")
        console.log(match_id)
        return request.get(`/playerMatch/match/${match_id}`);
    }

    static getByPlayer(player_id){
        return request.get(`/playerMatch/player/${player_id}`);
    }

    static create(player_match) {
        return request.post('/playerMatch',{player_match: player_match});
    }

    static edit(player_match, id){
        return request.put(`/playerMatch/${id}`, {player_match:player_match});
    }

    static delete(id){
        return request.delete(`playerMatch?id=${id}`);
    }
}


// WEBPACK FOOTER //
// ./src/api/Player_Match.js